import {StockItem} from '../../../shared-utilities/models-old/datastructures';
import {TLineColour} from '../../settings-new/models';

/**
 * Copies line colour description and value onto stock rows from the store palette map.
 */
export function applyLineColoursToStockManager(lineColour: TLineColour, stockItems: StockItem[]): StockItem[] {
  if (!lineColour || !stockItems?.length) {
    return stockItems || [];
  }
  return stockItems.map((stockItem: StockItem) => {
    const item = {...stockItem};
    if (item.lineColourCode && item.lineColourCode > 0) {
      const color = lineColour[item.lineColourCode];
      if (color) {
        item.lineColourDescription = color.description;
        item.lineColourValue = color.value;
      }
    }
    return item;
  });
}
